import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import settingsService from '../../services/settingsService';
import { toast } from 'react-toastify';
import styles from './VerifyTfaPage.module.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import authService from '../../services/authService';

const VerifyTfaPage: React.FC = () => {
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPin, setShowPin] = useState(false);
  const navigate = useNavigate();

  const handleVerify = async () => {
    setLoading(true);
    try {
      await authService.verify2FAPin(pin);
      localStorage.setItem('tfa_verified', 'true');
      toast.success('TFA verified!');
      navigate('/dashboard', { replace: true });
    } catch (e: any) {
      console.error('TFA verification failed:', e);
      
      // Check if it might be a time sync issue
      const now = new Date();
      const timeOffset = Math.abs(now.getTime() - Date.now());
      
      if (timeOffset > 30000) { // 30 seconds
        toast.error('Invalid PIN. Please check your device time is synchronized with the internet.');
      } else {
        toast.error(e?.response?.data?.error || 'Invalid PIN. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.tfaVerifyContainer}>
      <div className={styles.tfaCard}>
        <div className={styles.lockIcon}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="10" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
        </div>
        <h2>Two-Factor Authentication</h2>
        <p className={styles.tfaHelperText}>Enter your TFA PIN to continue</p>
        <div className={styles.pinInputRow}>
          <input
            type={showPin ? 'text' : 'password'}
            value={pin}
            onChange={e => setPin(e.target.value.replace(/\D/g, ''))}
            maxLength={6}
            minLength={4}
            placeholder="Enter PIN"
            disabled={loading}
            className={styles.pinInput}
            autoFocus
          />
          <button
            type="button"
            className={styles.pinToggleBtn}
            onClick={() => setShowPin(v => !v)}
            tabIndex={-1}
            aria-label={showPin ? 'Hide PIN' : 'Show PIN'}
            disabled={loading}
          >
            {showPin ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3.5"/><line x1="3" y1="3" x2="21" y2="21"/></svg>
            )}
          </button>
        </div>
        <div className={styles.tfaHelperText}>PIN must be 6 digits. Only numbers allowed.</div>
        <button
          className={styles.verifyBtn}
          onClick={handleVerify}
          disabled={loading || pin.length < 4}
        >
          {loading ? 'Verifying...' : 'Verify'}
        </button>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default VerifyTfaPage;
